import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

export function NotFoundPage() {
  return <Container size="sm" py="xl"><Stack><Title order={1}>Page not found</Title><Text c="dimmed">The page you’re looking for doesn’t exist.</Text><Button component={Link} to="/">Back to Page Outil</Button></Stack></Container>;
}
